export class MongoModel {
  _id: string;
  timestamp: Date;
}
